<template>
  <div class="boxes">
    <h3><Icon type="md-bookmarks" />重点风险报警（前十）<slot name="right"></slot></h3>
    <div v-for="(table, index) in tableDatas" :key="index">
      <h4 class="mintitle">{{ alarms[index] }}</h4>
      <Table :data="table" :columns="columns">
        <template slot-scope="{ row }" slot="alarmTotal">
          <span>{{ row.alarmTotal }}次</span>
        </template>
      </Table>
    </div>
    <div>
      <h4 class="mintitle">超速报警</h4>
      <Table :data="tableData" :columns="columns">
        <template slot-scope="{ row }" slot="alarmTotal">
          <span>{{ row.alarmTotal }}次</span>
        </template>
      </Table>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableDatas: [],
      tableData:[],
      columns: [
        {
          title: "序号",
          type: 'index',
          width: 100,
        },
        {
          title: "车牌号",
          key: "carNo",
        },
        {
          title: "所属单位",
          key: "groupName",
        },
        {
          title: "报警总数",
          key: "alarmTotal",
          slot: 'alarmTotal',
        },
      ],
      alarms: ["疲劳驾驶报警", "接打电话报警", "分神驾驶报警", "前向碰撞报警", "车道偏离报警", "车距过近报警", "抽烟报警"],
    };
  },
  methods: {
    getData(v) {
      v.limit = 10;
      v.alarmEventList = this.alarms;

      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-car-server-oam/report/countEvet",
        data: v,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        //console.log(res);
        this.tableDatas = res.data.data;
      });
    },
    getData1(v) {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-car-server-oam/report/countSpeed",
        data: v,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.item = res.data.data;
      });
    },
  },
  mounted() {
    ///cloud-car-server-oam/report/countEvet
  },
};
</script>
<style>
.mintitle {
  text-align: center;
  margin: 30px auto 20px auto;
  font-size: 18px;
  position: relative;
  width: 120px;
}
</style>


// WEBPACK FOOTER //
// src/components/dataAnalyse/anaReports/zhongdianfengxian.vue